<template>
  <div class="landing-share-container relative z-[1]">
    <TopHeader class="landing-share-container-top" />
    <iframe
      :src="iframeSrc"
      ref="iframeRef"
      class="full-iframe"
      frameborder="0"
      allowfullscreen
      @load="onIframeLoad"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import TopHeader from '~/design/widgets/top-header/index.vue';

const route = useRoute();
const iframeRef = ref<HTMLIFrameElement>();

// 计算iframe的src，将路由参数传递给iframe
const iframeSrc = computed(() => {
  // 这里替换为你实际的iframe页面URL
  const baseUrl = `/editor/page/lab-share`;
  // const baseUrl = 'https://test.youyan3d.com/editor/page/lab-share'
  // const baseUrl = 'http://localhost:5173/editor/page/lab-share'

  // 获取当前路由的查询参数
  const queryParams = new URLSearchParams();

  // 将路由参数传递给iframe
  Object.entries(route.query).forEach(([key, value]) => {
    if (value) {
      queryParams.append(key, String(value));
    }
  });

  // 也可以传递路由参数
  Object.entries(route.params).forEach(([key, value]) => {
    if (value) {
      queryParams.append(key, String(value));
    }
  });

  const queryString = queryParams.toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
});

// iframe加载完成回调
const onIframeLoad = () => {
  console.log('Iframe loaded successfully');
};

onMounted(() => {
  // 设置iframe高度为视口高度
  const setIframeHeight = () => {
    if (iframeRef.value) {
      iframeRef.value.style.height = `${window.innerHeight}px`;
    }
  };

  setIframeHeight();

  // 监听窗口大小变化
  window.addEventListener('resize', setIframeHeight);

  // 清理事件监听
  return () => {
    window.removeEventListener('resize', setIframeHeight);
  };
});
</script>

<style lang="scss" scoped>
.landing-share-container {
  width: 100%;
  height: 100%;
  padding: 0;
  @media (max-width: 640px) {
    .landing-share-container-top {
      display: none;
    }
  }
}
.landing-share-container-top {
  .header {
    background-color: var(--white-1);
  }
}
.iframe-container {
  width: 100%;
  height: calc(100vh - 100px);
  overflow: hidden;
}

.full-iframe {
  width: 100%;
  height: calc(100% - 80px);
  border: none;
  display: block;
}

/* 确保页面没有默认的margin和padding */
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
}
</style>
